import React from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames';
import Base from './containers/Base.jsx';
import {componentClassName, componentFileName} from '../../util/componentUtil.mjs';
import Question from './Question.jsx';
import Calculated from './types/Calculated.jsx';
import {QuestionTypeContext} from './QuestionComponentContext.mjs';

const QuestionGroupContainer = (props) => {
  const {
    GroupComponent = Base,
    className,
    page,
    questionGroup,
    validationErrors = []
  } = props;

  const classes = classnames(
    'questionGroup',
    `questionGroup--${ questionGroup.key }`,
    className
  );

  const renderQuestion = question => {
    const hasError = validationErrors.find(e => e.key === question.appkey && e.shouldDisplay);
    question.errors = hasError ? hasError.errors : undefined;
    const questionProps = {
      appkey: question.appkey,
      page,
      questionGroup,
      question,
    };
    const questionClasses = classnames('question', `${componentClassName(question.type)}Question`, {
      ['question--error']: hasError,
    });

    return (
      <QuestionTypeContext.Consumer key={question.appkey}>
        {QuestionTypes => {
          const QuestionComponent = QuestionTypes[componentFileName(question.type)] || Calculated;

          return (
            <Question
              component={QuestionComponent}
              {...questionProps}
              key={question.appkey}
              className={questionClasses}
            />
          );
        }}
      </QuestionTypeContext.Consumer>
    );
  };

  const renderChildren = () => (questionGroup.questions || []).map(q => renderQuestion(q, page));

  return (
    <GroupComponent
      className={classes}
      questionGroup={questionGroup}
      page={page}
      width={questionGroup.width || null}
      renderChildren={renderChildren}
      renderQuestion={renderQuestion}
    />
  );
};

QuestionGroupContainer.propTypes = {
  page: PropTypes.any.isRequired,
  questionGroup: PropTypes.any.isRequired,
  className: PropTypes.string,
  validationErrors: PropTypes.array,
  GroupComponent: PropTypes.any,
};

export default QuestionGroupContainer;
